<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("faq.import.title") }} </template>
        <template #sidebarMain>
            <CardToggle :title="$t('faq.import.import')">
                <div class="space-y-5">
                    <p class="ct-text">
                        {{ $t("faq.import.info") }}
                    </p>

                    <div class="my-4 ct-bg-2 rounded-xl p-4 ct-text space-y-2.5">
                        <p>
                            {{ $t("faq.import.question") }}1;{{ $t("faq.import.answer") }}1;{{
                                $t("faq.import.section")
                            }}1
                        </p>
                        <p>
                            {{ $t("faq.import.question") }}2;{{ $t("faq.import.answer") }}2;{{
                                $t("faq.import.section")
                            }}1
                        </p>
                        <p>
                            {{ $t("faq.import.question") }}3;{{ $t("faq.import.answer") }}3;{{
                                $t("faq.import.section")
                            }}2
                        </p>
                    </div>

                    <ButtonSecondarySm @click="exampleImport2" class="w-full">{{
                        $t("faq.import.download_example")
                    }}</ButtonSecondarySm>
                    <FormDivider />

                    <FormFiles
                        v-model="files"
                        accept="text/csv"
                        :title="$t('faq.import.upload_file')"
                        :single-file="true"
                        :labels="{
                            clickToUpload: $t('shared.uploader.click_to_upload'),
                            dragAndDrop: $t('shared.uploader.drag_and_drop'),
                            fileInfo: '',
                        }"
                        :maxSize="10000"
                        :errorMessages="{
                            invalidSize: $t('shared.invalid.file_size_over'),
                            invalidType: $t('shared.invalid.file_type'),
                        }"
                        @fileSelected="uploadFile"
                        @fileRemoved="removeFile"
                    />
                </div>
            </CardToggle>
            <CardToggle :title="$t('faq.import.export')">
                <div class="space-y-5">
                    <ButtonSecondarySm @click="exportQuestions" class="w-full">{{
                        $t("faq.import.export")
                    }}</ButtonSecondarySm>
                </div>
            </CardToggle>
        </template>
    </PageSidebar>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { PageSidebar } from "@easy/ui/page-components";
import { ButtonSecondarySm } from "@easy/ui/buttons";
import { FormDivider, FormFiles } from "@easy/ui/forms";
import { CardToggle } from "@easy/ui/cards";
import { FAQ_ROUTE_NAMES } from "@/apps/faq/faq.routes";

export default {
    components: {
        PageSidebar,
        ButtonSecondarySm,
        FormDivider,
        FormFiles,
        CardToggle,
    },
    computed: {
        ...mapState("faq", ["faq", "hasChanges"]),
    },
    data() {
        return {
            files: [],
        };
    },
    methods: {
        ...mapActions("faq", ["exampleImport2", "importQuestions2", "exportQuestions"]),
        ...mapActions("faq/projects", ["saveSnapshot"]),
        ...mapMutations("faq", ["toggleSections"]),
        uploadFile(file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                this.importQuestions2(event.target.result);
                this.$router.push({
                    name: FAQ_ROUTE_NAMES.projectQuestions,
                    query: { changes: "ignore" },
                });
                // file.uploadComplete(); // this will show 100% but with progress bar shown
                file.status = "DONE"; // this will hide progress bar.
            };
            reader.readAsText(file.originalFile);
        },
        removeFile() {
            this.files = [];
        },
    },
};
</script>
